import React, { useState ,useEffect} from 'react';

import '../Assets/css/custom.css';
import '../Assets/css/w3-css.css';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import Table from 'react-bootstrap/Table';
import Modal from 'react-bootstrap/Modal';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";   

import CommonAPI from '../Common/CommonAPI';
import CommonAPI2 from '../Common/FD_BILL_APIs';
import FadeLoader from "react-spinners/HashLoader"; 
import FDPayments from "./FDLoanPayments"
 
import moment from 'moment';

function FDLoans (props)  {  

 const [ SuccessLoading,setSuccessLoading] = useState(true);  
  const [SuccessfulMSG,setSuccessfulMSG] = useState();
  const [ErrorMSG,setErrorMSG] = useState();
  const [StartDate,setStartDate] = useState("");  
  const [EndDate,setEndDate] = useState("");
  const [LoanList,setLoanList] = useState([]);
  const [Status,setStatus] = useState("");
  const [Amount,setAmount] = useState(0);
  const [CheckFDPayments,setCheckFDPayments] = useState(false);  
  
    const GetFDLoansAPI = ()=>{
        var FromDate = StartDate?moment(StartDate).format("DD/MM/YYYY"):'';
        var ToDate = EndDate?moment(EndDate).format("DD/MM/YYYY"):'';
        setSuccessLoading(true);
        CommonAPI2.FDLoansAPI({Status:Status,Amount:Amount,FromDate:FromDate,ToDate:ToDate},(result)=>{
          setLoanList(result);
          setSuccessLoading(false);
        }
       )
      }

    useEffect( () => {
      GetFDLoansAPI();          
      },[]);
    
   
    const OnChangeLoanType = (event)=>{
        var passValFrom = JSON.parse(event.target.value);        
        setStatus(passValFrom);        
    }

    const OnChangeAmount= (event)=>{
        var passValFrom = JSON.parse(event.target.value);
        setAmount(passValFrom);
    }

    const ResponseLoadingModal = () => {
        return(
            <Modal
            size="lg"
            centered 
            className="loading1" show={SuccessLoading}>          
                  <FadeLoader
                  height={25}
                  width={5}
                  radius={2}
                  margin={2}
                  color={"#197b55"}
                  size={"80px"} this also works
                  loading={SuccessLoading}
                />       
           </Modal>
         )
    }

    const SaveLoanId = (ind)=>{

        var FdInfor = {
          fdNumber: ind.fdNumber,
          id:ind.id,
        }
        var value = JSON.stringify(FdInfor);
        sessionStorage.setItem('fdValue', value );
        setCheckFDPayments(true);
      }

    if(SuccessLoading){
        return ( <div>{ResponseLoadingModal()}</div> );
      }
        return (

            <div>
                {CheckFDPayments?
                <FDPayments isOpen={CheckFDPayments} toggle={()=>setCheckFDPayments(!CheckFDPayments)}/>
                :null}
                <Row className='block'>
                    <p className='p-line2'>FIXED DEPOSITS LOANS</p>
                </Row>
                
                <Form >
                    <Form.Group as={Row} className="mb-1">
                        <Form.Label className="c-font2" column sm={1}>
                            LOAN TYPE
                        </Form.Label>
                        <Col sm={2} >
                            <Form.Select 
                            onChange={OnChangeLoanType.bind(this)}
                            size="sm" 
                            className="form-h2 ">
                                <option value={JSON.stringify("")}>-Select Loan Type-</option>
                                <option value={JSON.stringify("A")}> Active </option>
                                <option value={JSON.stringify("R")}> Settled </option>                         
                            </Form.Select>
                        </Col>
                        
                       
                        <Form.Label className="c-font3" column sm={1}>
                            AMOUNT RANGE
                        </Form.Label>
                        <Col sm={2} >
                            <Form.Select 
                            onChange={OnChangeAmount.bind(this)}
                            size="sm" className="form-h2 ">
                            <option value={JSON.stringify("0")}>-All-</option>
                            <option value={JSON.stringify("1")}>Rs.0.00 - Rs.100,000.00</option>
                            <option value={JSON.stringify("2")}>Rs.100,000.00 - Rs.500,000.00</option>
                            <option value={JSON.stringify("3")}>Rs.500,000.00 - Rs.1,000,000.00</option>
                            <option value={JSON.stringify("4")}>More than Rs.1,000,000.00 </option>
                            </Form.Select>
                        </Col>
                        
                        
                        <Form.Label className=" c-font t-left" column sm={1}>
                            START DATE
                        </Form.Label>
                        <Col sm={1}  className="s-top2">
                            <DatePicker
                            className="datepicker3"
                            selected={StartDate}
                            onChange={(e)=>setStartDate(e)}
                            dateFormat="dd/MM/yyyy"                                
                            />
                        </Col>
                        
                        <Form.Label className="c-font" column sm={1}>
                                END DATE
                        </Form.Label>
                        <Col sm={1} >
                            <DatePicker
                            className="datepicker3"
                            selected={EndDate}
                            onChange={(e)=>setEndDate(e)}
                            dateFormat="dd/MM/yyyy"                                
                            />
                        </Col>
                        
                        <Col sm={1} > 
                            <Button 
                            onClick={()=>GetFDLoansAPI()}
                            className='btn-browse s-top2' variant="primary" type="submit">
                              SEARCH
                            </Button>                                 
                        </Col>
                    </Form.Group>                                             
                </Form>
                <div class="tableFixHead">
                    <Table   hover responsive>
                        <thead >
                            <tr >
                            <th className='td-width4 t-left'>Loan Date <p></p></th>
                            <th className='td-width4 t-left'>FD Number <p></p></th>
                            <th className='td-width4 t-left'>Status <p></p></th>                           
                            <th className='td-width4 t-left'>Capital Given<p></p></th>                           
                            <th className='td-width5 t-left'>Interest Paid<p></p></th>                           
                            <th className='td-width4 t-left'>VAT Paid<p></p></th>                           
                            <th className='td-width4 t-right'>Total Paid<p></p></th>                           
                            <th className='td-width5 t-right'>Capital <br/>Outstandin</th>                           
                            <th className='td-width5 t-right'>Int + VAT <br/>Outstanding</th>                           
                            <th className='td-width5 t-right'>Total Loan <br/>Outstanding</th>                           
                            <th className='td-width4 t-right'>Payments<p></p></th>                           
                            </tr>
                        </thead>
                        
                        <tbody className='scroll2'>
                        {LoanList.length>0?LoanList.map(( listValue, index ) => {
                        return( 
                            <tr>
                                <td className='td-width5'>
                                    <p className='tb-text m-top t-left'>{moment(listValue.date).format('DD/MM/YYYY')}</p>
                                </td>
                                <td className='td-width5'>
                                    <p className='tb-text m-top t-left'>{listValue.fdNumber}</p>
                                </td>
                                <td className='td-width5'>
                                    <p className='tb-text m-top t-left'>{listValue.status}</p>
                                </td>
                                <td className='td-width5'>
                                    <p className='tb-text m-top t-left'>{listValue.loanAmount.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</p>
                                </td>
                                <td className='td-width5'>
                                    <p className='tb-text m-top t-left'>{listValue.totalInterest.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</p>
                                </td>
                                <td className='td-width5'>
                                    <p className='tb-text m-top t-left'>{(listValue.vatPaid).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</p>
                                </td>
                                <td className='td-width5'>
                                    <p className='tb-text m-top t-right'>{listValue.totalPaid.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</p>
                                </td>
                                <td className='td-width5'>
                                    <p className='tb-text m-top t-right'> {listValue.loanCapitalOutstanding.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</p>
                                </td>
                                <td className='td-width5'>
                                    <p className='tb-text m-top t-right'>{listValue.interestVATOutstanding.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</p>
                                </td>
                                <td className='td-width5'>
                                    <p className='tb-text m-top t-right'>{listValue.loanOutstanding.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</p>
                                </td>
                                <td className='td-width10 t-right'>
                                    <Button  
                                    onClick={()=>{SaveLoanId(listValue)}}                               
                                    className='btn-browse' 
                                    variant="primary" type="submit">
                                        Payment
                                    </Button>
                                </td>                                     
                            </tr>
                        )
                            }):
                            <Row className='tablebody'>
                                <p className='h-text block-top'>No Records</p>
                            </Row>
                        }  
                        </tbody>
                    </Table>
                </div>
            </div>
          );
    }

export default FDLoans;